// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"6da709517682774e","487":"0786b6cec1f65ee5","868":"45376af625827551","921":"f25b044b722e2371"}[chunkId] + ".js";
};